var spriteIcons_default = [
  "error",
  "error-image",
  "empty-cart",
  "no-results"
];
export {
  spriteIcons_default as default
};
